// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__pov6Q","about":"about__PD2fd","aboutDescription":"aboutDescription__3dGnR","aboutContacts":"aboutContacts__1xNZ3","aboutColumns":"aboutColumns__2pUg9"};


//////////////////
// WEBPACK FOOTER
// ./components/about/styles.styl
// module id = W2pY
// module chunks = 0